import styled from '@emotion/styled';

export const InputErrorWrapper = styled.p`
  color: #9F0B0B;
  font-size: 12px;
  font-weight: bold;
  margin-top: 5px;
`;
